import { _axios } from "../../../Utils/Axios/axios";

export const getTeacherTeachItemsService = async (
  userToken: string,
  subjectId: string | number,
  teacherId: string | number
) => {
  const data = new FormData();
  //
  data.append("teacher_id", String(teacherId));
  data.append("subject_id", String(subjectId));
  //
  return _axios.post("/user_search_section", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
